export default __webpack_public_path__ + "static/media/Featured-Baby-Products.3549a49b.jpg";